// Environment configuration
const isDevelopment = process.env.NODE_ENV === 'development';

export const API_BASE_URL = isDevelopment
    ? 'http://localhost:8000'
    : 'https://convexity-back-cvgvd2ctarhxdtdq.canadacentral-01.azurewebsites.net';

export const getApiUrl = (endpoint: string): string => {
    return `${API_BASE_URL}${endpoint}`;
}; 